import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom"; // For navigating to different routes
import { CONTRYCODE_API } from "../../config/config";

const DataSection = ({ dataSections }) => {
  const [stateData, setStateData] = useState([]);
  const storedCountry = localStorage.getItem("country_code") || "IN";
  const [visibleStates, setVisibleStates] = useState([]); // Currently visible states
  const [loadedCount, setLoadedCount] = useState(1); // Number of states shown
  const navigate = useNavigate();

  const handleSectionClick = (item) => {
    // -----------start for when country select and can't match code ---------------------
    if (storedCountry !== item.country_code) {
      localStorage.setItem("country_name", item.label.trim());
      localStorage.setItem("city_name", item.label.trim());

      navigate(`/${item.label.replace(/\s+/g, "-", "")}/`.toLowerCase().trim());
      return;
    }
    // ----------- end for when country select and can't match code ---------------------
    localStorage.setItem("selectedSection", item.label);
    navigate(`/${item.label.replace(/\s+/g, "-", "")}/`.toLowerCase().trim());

  };
  const handleCitySectionClick = (isCity) => {
    if (isCity) {
      // Replace spaces with hyphens for a cleaner URL
      const formattedLabel = isCity.label.replace(/\s+/g, "-").toLowerCase().trim();
      localStorage.setItem("city_name", isCity.label.toLowerCase().trim());
      localStorage.setItem("country_name", isCity.label.toLowerCase().trim());
      navigate(`/city/${formattedLabel}/`.toLowerCase().trim());
      localStorage.setItem("selectedSection", isCity.label.toLowerCase().trim());
      navigate(`/${formattedLabel}/`.toLowerCase().trim());
    }
  };

  const fetchCountryData = async () => {
    try {
      const response = await axios.post(CONTRYCODE_API, {
        // country_code: storedCountry,
        country_code: "IN",
      });
      if (response.data !== null) {
        setStateData(response.data.states);
        setVisibleStates([response.data.states[0]]); // Load only first state initially
      } else {
        console.error(
          "Error: ",
          response.data.message || "Unexpected response status"
        );
      }
    } catch (error) {
      console.error("Error fetching country data:", error);
    }
  };
  const handleSeeMore = () => {
    const nextStates = stateData.slice(0, loadedCount + 1);
    setVisibleStates(nextStates);
    setLoadedCount(loadedCount + 1);
  };

  const handleSeeLess = () => {
    setVisibleStates([stateData[0]]); // Show only the first state
    setLoadedCount(1);
  };
  // Filter states that have citydata available
  const filteredStateData = stateData.filter(state => state.citydata.length > 0);
  useEffect(() => {
    fetchCountryData();
  }, []);

  return (
    <>
      {dataSections?.label && (
        <>
          <div className="fs-2 them-font them-font-color py-2">
            {dataSections.label}
          </div>
          <Row>
            {Array.isArray(dataSections?.data) &&
              dataSections.data.length > 0 ? (
              dataSections.data.map((item, index) => (
                <Col key={index} xs={6} sm={6} md={4} lg={2} className="mb-4">
                  <Card
                    className="rounded-4 border-dark theme-shadow country-card"
                    onClick={() => handleSectionClick(item)}
                  >
                    <Card.Body className="d-flex justify-content-center align-items-center">
                      <p className="them-font fs-6 mb-0">
                        {item.label}
                        <span className="d-none"> {item.country_code}</span>
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            ) : (
              <p>No data available.</p>
            )}
          </Row>

          {/* {storedCountry === "IN" &&
          stateData &&
          Array.isArray(stateData) &&
          stateData.length > 0 ? (
            stateData.map((state, stateIndex) => (
              <div key={stateIndex}>
                <div className="fs-2 them-font them-font-color py-2">
                  <h5>{state.label}</h5>
                </div> */}
          {/* States Data */}
          {storedCountry === "IN" && visibleStates.length > 0 && stateData && Array.isArray(stateData) ? (
            visibleStates.map((state, stateIndex) => (
              <div key={stateIndex}>
                <div className="fs-2 them-font them-font-color py-2">
                  <h5>{state.label}</h5>
                </div>
                <Row>
                  {state.citydata &&
                    state.citydata.map((city, cityIndex) => (
                      <Col
                        key={cityIndex}
                        xs={6}
                        sm={6}
                        md={4}
                        lg={2}
                        className="mb-4"
                      >
                        <Card
                          className="crs-pnt rounded-4 border-dark theme-shadow state-card"
                          onClick={() => handleCitySectionClick(city)}
                        >
                          <Card.Body className="d-flex justify-content-center align-items-center">
                            <p className="them-font fs-6 mb-0">{city.label}</p>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                </Row>
              </div>
            ))
          ) : (
            <p>No state data available.</p>
          )}
          {/* See More / See Less Button */}


          {filteredStateData.length > 1 && (
            <div className="text-center my-3">
              {loadedCount < filteredStateData.length ? (
                <button
                  className="rounded-4 btn-red-to-black-color-move"
                  onClick={handleSeeMore}
                >
                  <span> View More</span>
                </button>
              ) : (
                <button
                  className="rounded-4 btn-red-to-black-color-move"
                  onClick={handleSeeLess}
                >
                  <span> View Less</span>
                </button>
              )}
            </div>
          )}


        </>
      )}
    </>
  );
};

export default DataSection;
